/// JTF3-added-AB-22-05-12


// Setup the main variables
let count          = 0;
let msgCspErrorLog = [];

function addError(e) {
	// Store each error message in array
	msgCspErrorLog.push(
		'<hr><p>' +
		'<strong>Blocked URL: </strong><br>' +
		e.blockedURI +
		'</p>' +
		'<p>' +
		'<strong>Violated directive: </strong><br>' +
		e.violatedDirective +
		'</p>' +
		'<p>' +
		'<strong>Original policy: </strong><br>' +
		e.originalPolicy +
		'</p>'
	);
	// Update the count
	count++;
}

function displayErrors( msgCspErrorLog ) {
	// Get the log section id and single page class
	const idErrorLog = document.getElementById("csp_errors_log");
	// Check if they exist...
	if ( null != idErrorLog && 0 != msgCspErrorLog.length ) {
		// // Clear the 'None reported' message
		idErrorLog.innerHTML = '';
		// // Display each error in the log section
		for ( let error of msgCspErrorLog ) {
			const htmlObject = document.createElement('div');
			htmlObject.innerHTML = error;
			idErrorLog.append( htmlObject );
		}
	}
}

// Listen for CSP errors...
document.addEventListener(
	"securitypolicyviolation",
	function(e) {
		// // Store error in the array
		addError(e);
	}
);

// On page load...
window.onload = function() {
	// Display the errors currently in the array
	displayErrors( msgCspErrorLog );
	// Listen for CSP errors...
	document.addEventListener(
		"securitypolicyviolation",
		function(e) {
			// // Refresh the display
			displayErrors( msgCspErrorLog );
		}
	);
}
